
import hasPageMeta from '@/mixins/hasPageMeta'

export default {
    layout: 'empty',

    mixins: [hasPageMeta],

    middleware: 'auth',

    auth: 'guest',

    data() {
        return {
            model: {
                email: null,
            },
            error: null,
            sent: false,
        }
    },

    computed: {
        siteTitle() {
            return 'Reset Your Loverly Password'
        },
        title() {
            return 'Recover your Password'
        },
        subHeading() {
            return "Forgetting happens to the best of us. Let's fix it!"
        },
        succesHeading() {
            return "We've successfully sent a verification link to your email address. Please check your inbox to recover your password."
        },
    },

    methods: {
        save() {
            this.$axios.$post('api/v1/auth/password/forgot', this.model).then(() => {
                this.sent = true
            })
        },
    },
}
